import { API } from "../../backend";

export const signin = (user) =>
  fetch(`${API}/signin`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(user),
  })
    .then((r) => r.json())
    .catch((err) => console.log(err));

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("jwt", JSON.stringify({ admin: data.admin }));
    next();
  }
};

export const signout = (next) => {
  if (typeof window !== "undefined") {
    let adminData = null;
    try { adminData = JSON.parse(localStorage.getItem("jwt")); } catch {}

    localStorage.removeItem("jwt");
    next();

    const body = adminData?.admin
      ? { adminName: adminData.admin.name, adminRole: adminData.admin.role }
      : {};
    fetch(`${API}/signout`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).catch(() => {});
  }
};

export const isAutheticated = () => {
  if (typeof window === "undefined") return false;
  try {
    const stored = localStorage.getItem("jwt");
    return stored ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};
